/* eslint-disable import/no-unresolved */
export { unstable_batchedUpdates } from 'react-dom';


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/es/utils/reactBatchedUpdates.js
// module id = 1112
// module chunks = 0